import { initiateStore, setPRO } from './../redux/actions/proActions';
import { isPlatform } from '@ionic/react';
import Api from "../services/Api";
import store from "../redux/store"
// import { IAPProduct, IAPError, InAppPurchase2 as Store } from "@awesome-cordova-plugins/in-app-purchase-2";
import { addPro } from '../redux/actions/logInActions';
import "cordova-plugin-purchase"
import "cordova-plugin-purchase/www/store"
import { getPlatform } from './shop_helper_2';

declare interface Window { store: CdvPurchase.Store; }

const Store: CdvPurchase.Store = window.store 
const state = store.getState()
const api = Api.getInstance();

export const subscriptionId = () => {
  let idName = ''
  if(isPlatform('android')) {
    idName = 'pro_1_month_recu'
  } else {
    idName = 'Pro1MonthRecu'
  }
  return idName
}

export const platformType = () => {
  if(isPlatform('ios')){
    return 'App store'
  } else {
    return 'Google Play'
  }
}

export const storeType = () => {
  if(isPlatform('android')){
    return 3
  } else if(isPlatform('ios')){
    return 2
  } else {
    return 0
  }
}

export const checkIfProHasExpired = async (date: Date) => {
  if(isInThePast(date)) {
    if(state.store.storeReady) {
      if(state.store.owned) {
        sendStoreUpdate(3, storeType(), null)
        document.location.reload();
      } else {
        store.dispatch(addPro(false))
      }
    } else {
      if(isPlatform('capacitor')) {
        initiateStore(state.logIn.user.WTTeams)
      } else {
        store.dispatch(setPRO({...state.store, expired: true}))
      }
    }
  } else {
    store.dispatch(addPro(true))
  }
}

export const isInThePast = (date: Date) => {
  const today = new Date();
  const toDate = new Date(date) 

  return toDate < today;
}

export const sendStoreUpdate = async (typeId: number, storeType: number, expires: string | null) => {
//  store_type: 1  = backend staff
//  store_type: 2 = App store
//  store_type: 3 = Google play
//  expires = "2022-11-05 12:00:00"
  const req = {
    storeKey: 'PRO',
    typeId: typeId,        
    storeType: storeType,  
    expires: null
  }

  return new Promise((resolve) => {
    api.post('/purchase/store', req).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  })
}

export const manageSubscription = () => {
  Store.manageSubscriptions()
}

export const handlePurchase = () => {
  const product = Store.get(subscriptionId(), getPlatform()) as CdvPurchase.Product
  const offer = product.getOffer();
  // console.log(offer, JSON.stringify(offer))
  Store.order(offer as CdvPurchase.Offer).then(error => {
    if (error) {
      if (error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
        // Purchase flow has been cancelled by user
      }
      else {
        // Other type of error, check error.code and error.message
      }
    }
  });
}
